"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createObfuscatedNamesWithCountCellFormatter = exports.createObfuscatedCountsCellFormatter = exports.createObfuscatedTextWithIconCellFormatter = exports.createObfuscatedTextCellFormatter = exports.createObfuscatedLinkOrTextCellFormatter = exports.createObfuscatedLinkWithIconCellFormatter = exports.createObfuscatedLinkCellFormatter = exports.EmptyCell = exports.PermissionsRequiredCell = void 0;
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var React = require("react");
var Localize_1 = require("../../../../gen-src/Localize");
var LinkCellFormatter_1 = require("./LinkCellFormatter");
var NamesWithCountCell_1 = require("./NamesWithCountCell");
var PermissionsRequiredCell = function (props) { return React.createElement(data_catalog_shared_1.PlaceholderTextCell, { placeholderText: Localize_1.Messages.PermissionsRequired(), noPadding: props.noPadding }); };
exports.PermissionsRequiredCell = PermissionsRequiredCell;
var EmptyCell = function () { return React.createElement("div", null); };
exports.EmptyCell = EmptyCell;
function createObfuscatedLinkCellFormatter(shouldBeObfuscated, getTextFromRowData, getPathFromRowData, noPadding, disableTabIndex, ObfuscatedComponent, getDisabledFromRowData) {
    if (noPadding === void 0) { noPadding = false; }
    if (disableTabIndex === void 0) { disableTabIndex = false; }
    if (ObfuscatedComponent === void 0) { ObfuscatedComponent = exports.PermissionsRequiredCell; }
    return function (props) {
        return shouldBeObfuscated(props.row.data) ?
            React.createElement(ObfuscatedComponent, { noPadding: noPadding })
            : LinkCellFormatter_1.createLinkCellFormatter(getTextFromRowData, getPathFromRowData, noPadding, undefined, // useAnchor
            disableTabIndex, undefined, // getIconFromRowData
            undefined, // getLinkTitleFromRowData
            getDisabledFromRowData)(props);
    };
}
exports.createObfuscatedLinkCellFormatter = createObfuscatedLinkCellFormatter;
function createObfuscatedLinkWithIconCellFormatter(shouldBeObfuscated, getTextFromRowData, getPathFromRowData, noPadding, disableTabIndex, ObfuscatedComponent, getIconFromRowData, getLinkTitleFromRowData, getDisabledFromRowData) {
    if (noPadding === void 0) { noPadding = false; }
    if (disableTabIndex === void 0) { disableTabIndex = false; }
    if (ObfuscatedComponent === void 0) { ObfuscatedComponent = exports.PermissionsRequiredCell; }
    return function (props) {
        return shouldBeObfuscated(props.row.data)
            ? React.createElement(ObfuscatedComponent, { noPadding: noPadding })
            : LinkCellFormatter_1.createLinkCellFormatter(getTextFromRowData, getPathFromRowData, noPadding, false, // useAnchor
            disableTabIndex, getIconFromRowData, getLinkTitleFromRowData, getDisabledFromRowData)(props);
    };
}
exports.createObfuscatedLinkWithIconCellFormatter = createObfuscatedLinkWithIconCellFormatter;
function createObfuscatedLinkOrTextCellFormatter(shouldBeObfuscated, getTextFromRowData, getPathFromRowData, noPadding, targetBlank, useAnchor, ObfuscatedComponent) {
    if (noPadding === void 0) { noPadding = false; }
    if (targetBlank === void 0) { targetBlank = false; }
    if (useAnchor === void 0) { useAnchor = false; }
    if (ObfuscatedComponent === void 0) { ObfuscatedComponent = exports.PermissionsRequiredCell; }
    return function (props) {
        return shouldBeObfuscated(props.row.data) ?
            React.createElement(ObfuscatedComponent, { noPadding: noPadding })
            : LinkCellFormatter_1.createLinkOrTextCellFormatter(getTextFromRowData, getPathFromRowData, noPadding, targetBlank, useAnchor)(props);
    };
}
exports.createObfuscatedLinkOrTextCellFormatter = createObfuscatedLinkOrTextCellFormatter;
function createObfuscatedTextCellFormatter(shouldBeObfuscated, getTextFromRowData, placeholder, getDisabledFromRowData, ObfuscatedComponent) {
    if (ObfuscatedComponent === void 0) { ObfuscatedComponent = exports.EmptyCell; }
    return function (props) {
        return shouldBeObfuscated(props.row.data) ?
            React.createElement(ObfuscatedComponent, null)
            : data_catalog_shared_1.createTextCellFormatter(getTextFromRowData, placeholder, getDisabledFromRowData)(props);
    };
}
exports.createObfuscatedTextCellFormatter = createObfuscatedTextCellFormatter;
function createObfuscatedTextWithIconCellFormatter(shouldBeObfuscated, getTextFromRowData, getIconFromRowData, getCellTitleFromRowData, placeholder, getDisabledFromRowData, ObfuscatedComponent) {
    if (ObfuscatedComponent === void 0) { ObfuscatedComponent = exports.EmptyCell; }
    return function (props) {
        return shouldBeObfuscated(props.row.data) ?
            React.createElement(ObfuscatedComponent, null)
            : data_catalog_shared_1.createTextCellFormatter(getTextFromRowData, placeholder, getDisabledFromRowData, false, // noPadding
            getIconFromRowData, getCellTitleFromRowData)(props);
    };
}
exports.createObfuscatedTextWithIconCellFormatter = createObfuscatedTextWithIconCellFormatter;
function createObfuscatedCountsCellFormatter(shouldBeObfuscated, getCountFromRowData, getMaxFromRowData, colorPaletteName, getDisabledFromRowData, ObfuscatedComponent) {
    if (ObfuscatedComponent === void 0) { ObfuscatedComponent = exports.EmptyCell; }
    return function (props) {
        return shouldBeObfuscated(props.row.data) ?
            React.createElement(ObfuscatedComponent, null)
            : data_catalog_shared_1.createCountBarCellFormatter(getCountFromRowData, getMaxFromRowData, colorPaletteName, getDisabledFromRowData)(props);
    };
}
exports.createObfuscatedCountsCellFormatter = createObfuscatedCountsCellFormatter;
function createObfuscatedNamesWithCountCellFormatter(shouldBeObfuscated, getNamesFromRowData, getCountFromRowData, maxShown, ObfuscatedComponent, getDisabledFromRowData) {
    if (maxShown === void 0) { maxShown = 3; }
    if (ObfuscatedComponent === void 0) { ObfuscatedComponent = exports.EmptyCell; }
    return function (props) {
        return shouldBeObfuscated(props.row.data) ?
            React.createElement(ObfuscatedComponent, null)
            : NamesWithCountCell_1.createNamesWithCountCellFormatter(getNamesFromRowData, getCountFromRowData, maxShown, getDisabledFromRowData)(props);
    };
}
exports.createObfuscatedNamesWithCountCellFormatter = createObfuscatedNamesWithCountCellFormatter;
//# sourceMappingURL=ObfuscatedCellFormatter.js.map